import { Middleware } from 'redux';
import { NAVIGATE } from './actions';
import { navigateTo } from './handler';

export const navigationMiddleware: Middleware = () => (next) => (action) => {
  if (action?.type === NAVIGATE) {
    navigateTo(action.payload, Boolean(action.replace));
    return action;
  }

  return next(action);
};
